<div [formGroup]="form">
  <div class="open-button-toggle" [class]="buttonToggleClasses()">
    <mat-button-toggle-group [formControlName]="question.key" [id]="question.key" [class]="(question.settings && question.settings.size)" (change)="setActiveDisplay($event)">
      <mat-button-toggle *ngFor="let option of question?.settings?.choices" [value]="option.value"><span [innerHTML]="option.label | sanitizedHtml"></span></mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
